export default __webpack_public_path__ + "static/media/S3xCLUE2.c02fede4.jpg";